
// CnpjField.js

import React, { useState, useEffect } from 'react';

function CnpjField({ value, onChange }) {
  const [cnpj, setCnpj] = useState(value);
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    setCnpj(value);
  }, [value]);

  const handleChange = (e) => {
    const value = e.target.value;
    setCnpj(value);
    onChange(value);

    // Verificar se o CNPJ é válido
    const isValidCnpj = validateCnpj(value);
    setIsValid(isValidCnpj);
  };

  const validateCnpj = (cnpj) => {
    // Remova qualquer caractere que não seja número
    cnpj = cnpj.replace(/\D/g, '');

    // Verifique se o CNPJ tem 14 dígitos
    if (cnpj.length !== 14) return false;

    // Calcula o primeiro dígito verificador
    let sum = 0;
    let size = cnpj.length - 2;
    let numbers = cnpj.substring(0, size);
    let digits = cnpj.substring(size);
    let position = size - 7;

    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * position--;
      if (position < 2) position = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

    // Verifica o primeiro dígito verificador
    if (result !== parseInt(digits.charAt(0))) return false;

    // Calcula o segundo dígito verificador
    sum = 0;
    size = size + 1;
    numbers = cnpj.substring(0, size);
    position = size - 7;

    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * position--;
      if (position < 2) position = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

    // Verifica o segundo dígito verificador
    if (result !== parseInt(digits.charAt(1))) return false;

    return true;
  };

  const formatCnpj = (cnpj) => {
    // Formata o CNPJ (xx.xxx.xxx/xxxx-xx)
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  };

  const handleBlur = () => {
    // Formatar o CNPJ ao sair do campo
    setCnpj(formatCnpj(cnpj));
  };

  return (
    <div>
      <input
        type="text"
        value={cnpj}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Digite o CNPJ"
        style={{ width: '200px', height: '30px', marginBottom: '0px' }}
      />
      {!isValid && <p style={{ color: 'red' }}>CNPJ inválido ou incompleto. Insira um CNPJ válido.</p>}
    </div>
  );
}

export default CnpjField;